module.exports = __webpack_public_path__ + "static/sponsorship_img-07-a-891e106e8a5bcd837850c425e2a0be87.jpg";